import IssuerListContainer from '../helpers/IssuerListContainer';

class MolPayEBankingMYElement extends IssuerListContainer {
    public static type = 'molpay_ebanking_fpx_MY';
}

export default MolPayEBankingMYElement;
